import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export interface ModalInformationProps extends ModalProps {}
export default function ModalInformation({
  isOpen,
  children,
  onClickAction,
  onClose,
}: ModalInformationProps) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <Fragment>
          <Button className="btn btn--secondary" onClick={onClickAction}>
            {t('common.close')}
          </Button>
        </Fragment>
      }
    >
      <Fragment>
        <div className="modal__message">{children}</div>
      </Fragment>
    </Modal>
  );
}
